import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=96ba887c&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=96ba887c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba887c",
  null
  
)

export default component.exports